import { ComponentButton } from './ComponentButton';
import { PdfDownloadButton as PdfDownloadButtonType } from '@/schemas/sceneDataSchema';
import useToast from '@/hooks/use-toasts';
import useAnalytics, { eventName } from '@/hooks/use-analytics';
import { downloadFile } from '@/services/download-service';

function buildPdfDownloadPath(component: PdfDownloadButtonType): string {
  switch (component.kind) {
    case 'quote':
      return `/agency_api_v2/pdf/quote/${component.kind_id}`;
    default:
      throw new Error('Unsupported PDF download kind');
  }
}

export const PdfDownloadButton = ({ component }: { component: PdfDownloadButtonType }) => {
  const { trackClick } = useAnalytics();
  const { getToast } = useToast();
  const errorToast = getToast(component.error_toast_id ?? '');

  const onClick = () => {
    trackClick(eventName(component.id), {
      button_type: component.type,
      kind: component.kind,
      kind_id: component.kind_id,
    });

    downloadFile(buildPdfDownloadPath(component)).catch(() => {
      if (errorToast) {
        errorToast.open();
      }
    });
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
